import Vue from 'vue'
import axios from 'axios'
const openIdUrl = "https://api.kaiwuschool.com/api/djrz/";
export default {
  ajaxGet: function (url, succssCallback,errorCallback){
	  url = openIdUrl+url;
    url = this.GetUrl(url);
		//console.log(url);
    axios.get(url)
  .then(function(response) {
    var result=response.data;
    if(result.ReturnCode==-102){
      Vue.prototype.$alert(result.Message, '提示', {confirmButtonText: '确定',callback: action => {
          Vue.prototype.common.ClearlocalStorage("UnLockUserData");
          Vue.prototype.store.dispatch('hideActions');
          Vue.prototype.router.push({"name":"login"});
        }
      });
    }else{
      succssCallback(result);
    }
  })
  .catch(function (error) {
    if (errorCallback)
      errorCallback(error);
  });
  },
  ajaxPost: function (url, json, contentType, succssCallback,errorCallback) {
    var SignKey = "9c7b9399680658d308691f2acad58c0a";
    url = openIdUrl+url;
    //console.log(url);
    var timeStamp = Math.round(new Date().getTime() / 1000);
    const data =  (Vue.prototype.common.GetlocalStorage('UnLockUserData') != undefined ? Vue.prototype.common.GetlocalStorage('UnLockUserData') : "");
    var token = "";
    var userId=0;
    if(data){
      userId=JSON.parse(data).UserID;
      token=JSON.parse(data).Token;
    }

    var md5str = hex_md5(token + timeStamp + SignKey);
    md5str = unescape($URL.encode(md5str));
    json.TimeStamp=timeStamp;
    json.Sign=md5str;
    json.UserID=userId;
    json.Token=token;

    contentType=contentType!=""?contentType:"application/json; charset=utf-8";
    axios.post(url, JSON.stringify(json),{headers: {'Content-Type': contentType}})
    .then(function (response) {
      var result=response.data;
      if(result==-102){
          self.$alert(data.Message, '温馨提示', {confirmButtonText: '确定',callback:function(){
            Vue.prototype.common.ClearlocalStorage("UnLockUserData");
            Vue.prototype.$store.dispatch('hideActions');
            Vue.prototype.$router.push({"name":"login"});
          }
        });
      }else{
        succssCallback(result);
      }
    })
    .catch(function (error) {
      if (errorCallback)
        errorCallback(error);
    });
  },
  //密码加密
  get_pwd_hash: function(pwd, usr) {
  	var md5str = hex_md5(pwd);
  	return ansi_md5(unescape($URL.encode(md5str + usr)));
  },
  signstr: function (params){
    var SignKey = "9c7b9399680658d308691f2acad58c0a";
    var md5str = hex_md5(params + SignKey);
    md5str = unescape($URL.encode(md5str));
    return md5str;
  },
  GetParams: function (str){
    var params = "";
    var num = str.indexOf("?");
    str = str.substr(num + 1);
    var arr = str.split("&");
    for (var i = 0; i < arr.length; i++) {
      num = arr[i].indexOf("=");
      if (num > 0) {
        params += arr[i].substr(num + 1)
      }
    }
    return params
  },
  GetUrl:function(url){
    var self = this;
    var SignKey = "9c7b9399680658d308691f2acad58c0a";
    var params = self.GetParams(url);

    const data =  (Vue.prototype.common.GetlocalStorage('UnLockUserData') != undefined ? Vue.prototype.common.GetlocalStorage('UnLockUserData') : "");
    var token = "";
    if(data)
      token=JSON.parse(data).Token;

    params=params+token;
    if (url.indexOf("TimeStamp=") == -1) {
      if (url.indexOf("?") == -1) {
        url += '?'
      } else {
        url += '&'
      }
      var timeStamp = Math.round(new Date().getTime() / 1000);
      url += 'TimeStamp=' + timeStamp;
      params = params + timeStamp;
    }
    var md5str = hex_md5(params + SignKey);
    md5str = unescape($URL.encode(md5str));

    if (url.indexOf("&Sign=") == -1) {
      url += '&Sign=' + md5str;
    }

    if(url.indexOf("&Token=")==-1){
      url+='&Token='+token;
    }

    return url;
  },
  dateFormat(fmt,date)
  {
    var o = {
      "y" : date.getFullYear(),
      "M" : (date.getMonth()+1).toString().length==1?"0"+(date.getMonth()+1).toString():(date.getMonth()+1).toString(),                 //月份
      "d" : date.getDate().toString().length==1?"0"+date.getDate().toString():date.getDate().toString(),                    //日
      "h" : date.getHours().toString().length==1?"0"+date.getHours().toString():date.getHours().toString(),                   //小时
      "m" : date.getMinutes().toString().length==1?"0"+date.getMinutes().toString():date.getMinutes().toString(),                 //分
      "s" : date.getSeconds().toString().length==1?"0"+date.getSeconds().toString():date.getSeconds().toString(),                 //秒
      "q" : Math.floor((date.getMonth()+3)/3), //季度
      "S"  : date.getMilliseconds()             //毫秒
    };

    var str=o.y+"-"+o.M+"-"+o.d;

    if(fmt=="yyyy-MM-dd hh:mm:ss"){
      str=str+" "+o.h+":"+o.m+":"+o.s;
    }else if(fmt=="yyyy-MM-dd hh"){
      str=str+" "+o.h;
    }

    return str;

    // if(/(y+)/.test(fmt))
    //   fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length));
    // for(var k in o)
    //   if(new RegExp("("+ k +")").test(fmt))
    // fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
    // return fmt;
  },
  dateFormat1(fmt,date){
    var d=date.replace("T"," ");
    if(fmt=="yyyy-MM-dd hh:mm:ss"){
      var i=date.indexOf(".");
      if(i!=-1){
        d=d.substring(0,i);
      }
    }else {
      d=d.substring(0,10);
    }

    return d;
  }
}



// WEBPACK FOOTER //
// ./src/action/axios.js